import React from 'react'
import format from 'civic-champs-shared/utils/format'
import { ExportButton } from 'core/table/components'

const filename = 'surveys.csv'
const headers = [
  { label: 'Name', key: 'name' },
  { label: 'Created On', key: 'createdAt' },
  { label: 'Created By', key: 'createdBy' },
  { label: 'Last Edited On', key: 'lastEditedOn' },
  { label: 'Last Edited By', key: 'lastEditedBy' },
]

const formatPerson = (person: any) => (person ? `${person.givenName} ${person.familyName}` : null)

const formatData = (questionnaires: any[]) => {
  return questionnaires.map(({ original: { versions, createdAt, createdBy } }) => ({
    name: versions[0]?.questionSet?.name,
    createdAt: format.datetime(createdAt),
    createdBy: formatPerson(createdBy),
    lastEditedOn: format.datetime(versions[0]?.createdAt),
    lastEditedBy: formatPerson(versions[0]?.questionSet?.createdBy),
  }))
}

export const ExportMentorshipSurveysButton = ({ data, disabled }: { data: any[]; disabled?: boolean }) => (
  <ExportButton data={data} disabled={disabled} formatData={formatData} headers={headers} filename={filename} />
)

export default ExportMentorshipSurveysButton
